import moment from "moment";
import React from "react";

const InvoiceA5 = React.forwardRef((props, ref) => {
  const { values } = props;

  return (
    <div ref={ref} style={styles.container}>
      <div className="text-regular text-[0.65rem] pb-6">
        <div style={{ width: "20.5cm" }} className="flex justify-between">
          <div
            style={{
              height: "2.1cm",
              width: "6.8cm",
            }}
          >
            <table>
              <tbody>
                <tr className="text-[0.53rem]">
                  <td></td>
                  <td className="px-2">&nbsp;</td>
                  <td>
                    {values?.customer?.name
                      ? values?.customer?.name
                      : "Walk-in-customer"}
                  </td>
                </tr>
                <tr className="text-[0.53rem]">
                  <td className="pl-3"></td>
                  <td className="px-2">&nbsp;</td>
                  <td>
                    {values?.customer?.city ? values?.customer?.city : ""}
                  </td>
                </tr>
                <tr className="text-[0.53rem]">
                  <td className="pl-3"></td>
                  <td className="px-2">&nbsp;</td>
                  <td>
                    {values?.customer?.area ? values?.customer?.area : ""}
                  </td>
                </tr>
                <tr className="text-[0.53rem]">
                  <td style={{ width: "2.2cm" }}></td>
                  <td className="px-2">&nbsp;</td>
                  <td className="">
                    {values?.customer?.state
                      ? values?.customer?.state +
                        ", " +
                        values?.customer?.country
                      : values?.customer?.country || ""}
                  </td>
                </tr>
                <tr className="text-[0.53rem]">
                  <td style={{ width: "2.2cm" }}></td>
                  <td className="px-2">&nbsp;</td>
                  <td className="">
                    {values?.customer?.tax ? values?.customer?.tax : ""}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            style={{
              height: "2.1cm",
              width: "6.9cm",
              textAlign: "right",
            }}
            className="text-sm text-medium "
          >
            <div style={{ textAlign: "center", width: "100%" }}>
              TAX INVOICE
            </div>
          </div>
          <div
            style={{
              height: "2.1cm",
              width: "6.8cm",
              textAlign: "left",
            }}
          >
            <table style={{ textAlign: "left", width: "100%" }}>
              <tbody>
                <tr className="text-[0.53rem]">
                  <td>{/* Invoice No */}</td>
                  <td className="">&nbsp;</td>
                  <td className="text-right">#INV-{values?.number}</td>
                </tr>
                <tr className="text-[0.53rem]">
                  <td>{/* Date */}</td>
                  <td className="">&nbsp;</td>
                  <td className="text-right">
                    {moment?.(values?.date)?.format?.("DD/MM/YYYY")}
                  </td>
                </tr>
                <tr className="text-[0.53rem]">
                  <td>{/* Date */}</td>
                  <td className="">&nbsp;</td>
                  <td className="text-right">N/A</td>
                </tr>
                <tr className="text-[0.53rem]">
                  <td>{/* Date */}</td>
                  <td className="">&nbsp;</td>
                  <td className="text-right">
                    {values?.payment_status == 2
                      ? values?.payments
                          ?.map((v, i) => (i > 0 ? ", " : "") + v?.name)
                          .join("")
                      : "CREDIT"}
                  </td>
                </tr>
                <tr className="text-[0.53rem]">
                  <td>{/* Date */}</td>
                  <td className="">&nbsp;</td>
                  <td className="text-right">
                    {moment?.(new Date())?.format?.("DD/MM/YYYY")}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* Items Table */}
      {/* <div style={{ height: "6.6cm" }}> */}
      <div style={{ height: "6.4cm" }}>
        <table style={{ width: "20.5cm" }}>
          <thead style={{ height: "0.7cm" }}>
            <tr className="">
              <th className="text-[0.65rem] font-normal">
                <div style={{ width: "1.2cm" }}></div>
              </th>
              <th className="text-[0.65rem] font-normal">
                <div style={{ width: "11.8cm" }}></div>
              </th>
              <th className="text-[0.65rem] font-normal">
                <div style={{ width: "1.4cm" }}></div>
              </th>
              <th className="text-[0.65rem] font-normal">
                <div style={{ width: "1.4cm" }}></div>
              </th>
              <th className="text-[0.65rem] font-normal">
                <div style={{ width: "1.4cm" }}></div>
              </th>
              <th className="text-[0.65rem] font-normal">
                <div style={{ width: "1.4cm" }}></div>
              </th>
              <th className="text-[0.65rem] font-normal">
                <div style={{ width: "1.6cm" }}></div>
              </th>
              <th
                className="text-[0.65rem] font-normal text-right"
                style={styles.tableCell}
              >
                <div style={{ width: "1.6cm" }}></div>
              </th>
            </tr>
          </thead>
          <tbody className="text-regular" style={{ minHeight: "5.8cm" }}>
            {values?.details?.map((item, index) => (
              <tr className="text-[0.65rem]" key={index}>
                <td className="text-[0.65rem] font-normal">
                  <div style={{ width: "1.2cm" }}>{index + 1}</div>
                </td>
                <td className="text-[0.65rem] font-normal">
                  <div style={{ width: "11.8cm" }}>{item?.name}</div>
                </td>
                <td className="text-[0.65rem] font-normal">
                  <div style={{ width: "1.4cm" }}> {item?.quantity} </div>
                </td>
                <td className="text-[0.65rem] font-normal">
                  <div style={{ width: "1.4cm" }}>
                    {item?.sale_price?.toFixed(3)}
                  </div>
                </td>
                <td className="text-[0.65rem] font-normal">
                  <div style={{ width: "1.4cm" }}>
                    {item?.sale_price?.toFixed(3)}
                  </div>
                </td>
                <td className="text-[0.65rem] font-normal">
                  <div style={{ width: "1.4cm" }}>{item?.tax}%</div>
                </td>
                <td className="text-[0.65rem] font-normal">
                  <div style={{ width: "1.2cm" }}>
                    {item?.tax_amount?.toFixed(3)}
                  </div>
                </td>
                <td className="text-[0.65rem] font-normal">
                  <div style={{ width: "1.6cm" }}>
                    {item?.total?.toFixed(3)}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="">
        <table>
          <tfoot
            style={{ height: "1cm", verticalAlign: "top" }}
            className="text-regular"
          >
            <tr>
              <td className="text-[0.65rem] font-normal">
                <div style={{ width: "1.2cm" }}></div>
              </td>
              <td className="text-[0.65rem] font-normal">
                <div style={{ width: "11.8cm" }}></div>
              </td>
              <td className="text-[0.65rem] font-normal">
                <div style={{ width: "1.4cm" }}></div>
              </td>
              <td className="text-[0.65rem] font-normal">
                <div style={{ width: "1.4cm" }}></div>
              </td>
              <td className="text-[0.65rem] font-normal">
                <div style={{ width: "1.4cm" }}></div>
              </td>
              <td className="text-[0.65rem] font-normal">
                <div style={{ width: "1.4cm" }}></div>
              </td>
              <td className="text-[0.65rem] font-normal">
                <div style={{ width: "1.2cm" }}></div>
              </td>
              <td className="text-[0.65rem] font-normal">
                <div style={{ width: "1.4cm" }}>
                  <div className="text-[0.65rem]">
                    {values?.discount ? "-" + values?.discount?.toFixed(3) : ""}
                  </div>
                  <div>&nbsp;{values?.total?.toFixed(3)}</div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
});

const styles = {
  container: {
    width: "21.5cm",
    height: "14cm",
    marginTop: "3cm",
    marginLeft: "0.5cm",
    marginRight: "0.5cm",
    marginBottom: "1.3cm",
  },
};

export default InvoiceA5;
